import React from "react";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import {isDefined, isPresent} from "../../utils/utils";



const IconTooltip = ({
  tooltipPosition,
  tooltipIcon,
  tooltipTitle,
  tooltipContent,
  tooltipContent2,
  tooltipContent3,
  tooltipContentComponent,
  link,
  iconColor,
  handleClick,
  handleMouseLeave,
  additionalClassesForIcon,
  margins,
  targetLink,
  customHtml,
  customComponentToRender,
  customComponentToRenderCssClass,
  customComponentToRenderStyle,
  customTxt,
  customTxtId
}) => {

  return (
    <OverlayTrigger
      key={tooltipPosition}
      placement={tooltipPosition}
      trigger={link && 'click'}
      overlay={
        tooltipContentComponent ?
          <Tooltip id={`tooltip-${tooltipPosition}`}>
            { tooltipContentComponent }
          </Tooltip>
        :
          tooltipContent3 ?
            <Tooltip id={`tooltip-${tooltipPosition}`}>
              {
                tooltipTitle &&
                <p className="text-weight-700">
                  {
                    link ?
                      <a href={link} className="color-white" target={targetLink ? targetLink : ''}>{tooltipTitle.toUpperCase()}</a>
                      :
                      tooltipTitle.toUpperCase()
                  }

                </p>
              }
              {tooltipContent3.split('. ').map((paragraph, i) => (
                <p key={i} className="text-left">{paragraph}</p>
              ))
              }
            </Tooltip>
            :
            !tooltipContent2 ?
              <Tooltip id={`tooltip-${tooltipPosition}`}>
                {
                  tooltipTitle &&
                  <p className="text-weight-700">
                    {
                      link ?
                        <a href={link} className="color-white" target={targetLink ? targetLink : ''}>{tooltipTitle.toUpperCase()}</a>
                        :
                        tooltipTitle.toUpperCase()
                    }

                  </p>
                }
                {tooltipContent.split('. ').map((paragraph, i) => (
                  <p key={i} className="text-justify">{paragraph}</p>
                ))
                }
              </Tooltip>
              :
              <Tooltip id={`tooltip-${tooltipPosition}`}>
                {
                  tooltipTitle &&
                  <p className="text-weight-700">{tooltipTitle.toUpperCase()}</p>
                }
                <p key={tooltipContent2} className="text-justify pl-3 pr-3">{tooltipContent2}</p>
              </Tooltip>
      }
    >
      {
        isDefined(customTxt) ?
          <span id={`${customTxtId ? customTxtId : ''}`} className="cursor-default">{customTxt}</span>
          :
          customComponentToRender ?
            <div className={isPresent(customComponentToRenderCssClass) ? customComponentToRenderCssClass : 'text-truncate'}
                style={isDefined(customComponentToRenderStyle) ? customComponentToRenderStyle : {}}
            >
              {customComponentToRender}
            </div>
            :
            customHtml ?
              <div dangerouslySetInnerHTML={{ __html: customHtml }}></div>
              :
              <i className={`${tooltipIcon} ${margins ? margins : 'ml-3'} fa-lg ${additionalClassesForIcon || ''}`}
                id="tooltip" style={{ color: iconColor }}
                onClick={(e) => handleClick ? handleClick() : {}}
                onMouseLeave={(e) => handleMouseLeave ? handleMouseLeave() : {}}
              />
      }
    </OverlayTrigger>

  )
}

export default IconTooltip;